import { PAYMENT_PROVIDERS } from "../constants/payment-providers";

interface PaymentProviderProps {
  provider: string;
  className?: string;
}

export function PaymentProvider({ provider, className }: PaymentProviderProps) {
  const providerConfig = PAYMENT_PROVIDERS[provider.toLowerCase()];

  return (
    <div 
      className={`flex items-center gap-2 px-3 py-1.5 rounded-lg ${className}`}
      style={{
        backgroundColor: providerConfig.theme.background,
        color: providerConfig.theme.text,
        border: `1px solid ${providerConfig.theme.border}`,
      }}
    >
      {providerConfig.icon && (
        <img 
          src={providerConfig.icon} 
          alt={`${providerConfig.displayName} icon`}
          className="w-5 h-5"
        />
      )}
      <span className="text-sm font-medium">{providerConfig.displayName}</span>
    </div>
  );
}